import { render, staticRenderFns } from "./ControlForm.vue?vue&type=template&id=229aa8e7"
import script from "./ControlForm.vue?vue&type=script&lang=js"
export * from "./ControlForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports